const MAX_SLUG_LENGTH = 80;

export function slugify(value) {
  const slug = String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SLUG_LENGTH);

  return slug;
}

export function buildCourseSlug(id, title) {
  if (id == null || id === '') return '';
  const slug = slugify(title);
  return slug ? `${slug}-${id}` : String(id);
}

export function getCourseSlugParam(courseOrId, title) {
  if (courseOrId && typeof courseOrId === 'object') {
    if (courseOrId.slug) return courseOrId.slug;
    return buildCourseSlug(courseOrId.id, courseOrId.title);
  }

  return buildCourseSlug(courseOrId, title);
}

export function parseCourseIdFromSlug(param) {
  const value = String(param || '').trim();
  if (!value) return null;
  if (/^\d+$/.test(value)) return value;

  const match = value.match(/-(\d+)$/);
  return match ? match[1] : null;
}

export function buildTeacherSlug(id, name) {
  return buildCourseSlug(id, name);
}

export function getTeacherSlugParam(teacherOrId, name) {
  if (teacherOrId && typeof teacherOrId === 'object') {
    if (teacherOrId.slug) return teacherOrId.slug;
    return buildTeacherSlug(teacherOrId.id, teacherOrId.name);
  }

  return buildTeacherSlug(teacherOrId, name);
}

export const parseTeacherIdFromSlug = parseCourseIdFromSlug;
